import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import AnttButton from "../../../vendors/components/Button";
import {
  faCheck,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

interface Props {
  visible: boolean;
  onHide: () => void;
  onConfirm: (noMoreMessage: boolean) => void;
  isUltimoItem?: boolean;
}

export default function ConfirmacaoSalvar({
  visible,
  onHide,
  onConfirm,
  isUltimoItem = true,
}: Props) {
  const [checked, setChecked] = useState(false);

  const handleConfirm = () => {
    onConfirm(checked);
    setChecked(false);
  };

  const handleHide = () => {
    setChecked(false);
    onHide();
  };

  const dialogFooter = (
    <div className="confirmacao-salvar-footer">
      <div className="confirmacao-salvar-checkbox">
        <Checkbox
          inputId="confirmacao-salvar-checkbox"
          value="0"
          checked={checked}
          onChange={() => setChecked(!checked)}
        />
        <label
          htmlFor="confirmacao-salvar-checkbox"
          className="confirmacao-salvar-checkbox__label"
        >
          Não quero mais ver esta mensagem
        </label>
      </div>
      <div className="confirmacao-salvar-actions">
        <AnttButton
          className="p-button-text p-button-secondary"
          label="Cancelar"
          onClick={handleHide}
        />
        <AnttButton
          faIcon={faCheck}
          color="white"
          onClick={handleConfirm}
          className="confirmacao-salvar-btn"
        >
          <span className="ml-2">
            {isUltimoItem ? "Salvar" : "Salvar e continuar"}
          </span>
        </AnttButton>
      </div>
    </div>
  );

  return (
    <Dialog
      header="Confirmar salvamento"
      draggable={false}
      style={{ width: "420px" }}
      visible={visible}
      onHide={handleHide}
      footer={dialogFooter}
      modal
      className="confirmacao-salvar-dialog"
    >
      <div className="confirmacao-salvar-body">
        <div className="confirmacao-salvar-alert">
          <div className="confirmacao-salvar-alert__icon">
            <i className="pi pi-exclamation-triangle" />
          </div>
          <div className="confirmacao-salvar-alert__content">
            <p className="confirmacao-salvar-alert__title">Atenção</p>
            <p className="confirmacao-salvar-alert__text">
              Sua contribuição pode ser alterada enquanto o evento estiver em seu periodo de contribuição
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
